import script from "./resource-tree.vue?vue&type=script&setup=true&lang=js"
export * from "./resource-tree.vue?vue&type=script&setup=true&lang=js"

import "./resource-tree.vue?vue&type=style&index=0&id=774e04a8&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774e04a8"]])

export default __exports__